export default function BorderIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 1.66667V13.3333C0 14.25 0.75 15 1.66667 15H13.3333C14.25 15 15 14.25 15 13.3333V1.66667C15 0.75 14.25 0 13.3333 0H1.66667C0.75 0 0 0.75 0 1.66667ZM6.66667 13.3333H2.5C2.04167 13.3333 1.66667 12.9583 1.66667 12.5V8.33333H5.83333C6.29167 8.33333 6.66667 8.70833 6.66667 9.16667V13.3333ZM5.83333 6.66667H1.66667V2.5C1.66667 2.04167 2.04167 1.66667 2.5 1.66667H6.66667V5.83333C6.66667 6.29167 6.29167 6.66667 5.83333 6.66667ZM12.5 13.3333H8.33333V9.16667C8.33333 8.70833 8.70833 8.33333 9.16667 8.33333H13.3333V12.5C13.3333 12.9583 12.9583 13.3333 12.5 13.3333ZM13.3333 6.66667H9.16667C8.70833 6.66667 8.33333 6.29167 8.33333 5.83333V1.66667H12.5C12.9583 1.66667 13.3333 2.04167 13.3333 2.5V6.66667Z"
        fill="#878686"
      />
    </svg>
  );
}
